import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const ToastContext = React.createContext({
    success: () => { },
    error: () => { },
    info: () => { },
});
export const useToast = () => React.useContext(ToastContext);
let idCounter = 0;
const ALERT_CLASS = {
    success: 'alert-success',
    error: 'alert-danger',
    info: 'alert-info',
};
const ICON_CLASS = {
    success: 'bi-check-circle-fill',
    error: 'bi-exclamation-triangle-fill',
    info: 'bi-info-circle-fill',
};
export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = React.useState([]);
    const dismiss = React.useCallback((id) => {
        setToasts(prev => prev.map(t => t.id === id ? Object.assign(Object.assign({}, t), { exiting: true }) : t));
        setTimeout(() => {
            setToasts(prev => prev.filter(t => t.id !== id));
        }, 300);
    }, []);
    const createToast = React.useCallback(({ message, kind, timeout }) => {
        const id = `toast-${++idCounter}`;
        setToasts(prev => [...prev, { id, message, kind, exiting: false }]);
        const ms = timeout !== null && timeout !== void 0 ? timeout : (kind === 'error' ? 5000 + Math.min(message.split('\n').length * 1000, 5000) : 3000);
        setTimeout(() => dismiss(id), ms);
    }, [dismiss]);
    const ctx = React.useMemo(() => ({
        success: (message) => createToast({ message, kind: 'success' }),
        error: (message) => createToast({ message, kind: 'error' }),
        info: (message) => createToast({ message, kind: 'info' }),
    }), [createToast]);
    return (_jsxs(ToastContext.Provider, { value: ctx, children: [children, _jsx("div", { className: "toast-container", children: toasts.map(t => (_jsxs("div", { className: `toast-item alert ${ALERT_CLASS[t.kind]} ${t.exiting ? 'toast-item-exit' : ''}`, children: [_jsx("i", { className: `bi ${ICON_CLASS[t.kind]} me-2` }), _jsx("span", { style: { whiteSpace: 'pre-line' }, children: t.message }), _jsx("button", { type: "button", className: "btn-close ms-auto", onClick: () => dismiss(t.id) })] }, t.id))) })] }));
};
